import { render, staticRenderFns } from "./MainSection.vue?vue&type=template&id=480c9e0a&scoped=true&"
import script from "./MainSection.vue?vue&type=script&lang=js&"
export * from "./MainSection.vue?vue&type=script&lang=js&"
import style0 from "./MainSection.vue?vue&type=style&index=0&id=480c9e0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480c9e0a",
  null
  
)

export default component.exports